<app-menu [stickyInput]="true"></app-menu>
<app-page-head [dataHeader]="pageHead"></app-page-head>
<app-registration-form></app-registration-form>
<app-sponsors></app-sponsors>
<app-footer></app-footer>
